import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import { sectionNames } from "@dashboard/intl";
import { parseQs } from "@dashboard/url-utils";
import { useIntl } from "react-intl";
import { type RouteComponentProps, Switch } from "react-router-dom";

import { atticActivityListPath, type AtticActivityListUrlQueryParams } from "./urls";
import AtticActivityListView from "./views/AtticActivityList";

const ActivityList = ({ location }: RouteComponentProps) => {
  const params: AtticActivityListUrlQueryParams = parseQs(location.search.substr(1));

  return <AtticActivityListView params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.atticActivityLog)} />
      <Switch>
        <Route exact path={atticActivityListPath} component={ActivityList} />
      </Switch>
    </>
  );
};

export default Component;
